import { ITimelineItem } from '../components/timeline/timeline.component';

export function parseFixSuggestionFieldToTimelineWithNestedBullets(fixSuggestion: string): ITimelineItem[] {
  if (!fixSuggestion?.trim()) {
    return [];
  }

  const lines = fixSuggestion.split(/\r?\n/).filter((line) => line.trim() !== '');
  const result: ITimelineItem[] = [];

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const trimmedLine = line.trim();

    // Check if this line starts with a tab followed by a dash (bullet point)
    if (line.match(/^\s+-\s/)) {
      // This is a bullet point - add it as a nested item to the previous main item
      const bulletText = trimmedLine.substring(2).trim(); // Remove "- " prefix

      if (result.length > 0) {
        // Add to the previous main item's nested items
        const lastItem = result[result.length - 1];
        if (!lastItem.nestedItems) {
          lastItem.nestedItems = [];
        }
        lastItem.nestedItems.push({ text: bulletText });
      } else {
        // If there's no previous main item, create one with empty text
        result.push({
          text: '',
          nestedItems: [{ text: bulletText }],
        });
      }
    } else {
      // This is a main item (step title)
      const mainText = trimmedLine.replace(/^\t/, '').trim(); // Remove leading tab if present
      result.push({ text: mainText });
    }
  }

  return result;
}
